import React, { useEffect, useState } from "react";
import { enqueueSnackbar } from "notistack";
import { useSelector } from "react-redux";
import addRefundMessage from "../../../../controllers/booking/postTicketing/refund/addRefundMessage";
import { canAddRefundRemark } from "../../../../data/flight/order/getRefundAdminGuidance";

function RefundConfirmationRemarks({ data }) {
  const { user } = useSelector((state) => state.user?.userData);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [conversation, setConversation] = useState(data?.conversation || []);

  useEffect(() => {
    setConversation(data?.conversation || []);
  }, [data]);

  const canReply = canAddRefundRemark(data);

  if (!canReply && conversation?.length === 0 && !data?.remark) return null;

  const handleReply = async () => {
    if (!message.trim())
      return enqueueSnackbar("Enter a note before sending.", {
        variant: "info",
      });
    setLoading(true);
    const res = await addRefundMessage(data?._id, {
      message: message.trim(),
    }).finally(() => setLoading(false));
    if (res?.return) {
      setMessage("");
      setConversation([
        ...conversation,
        res?.data || { message: message.trim(), account: user?._id },
      ]);
    } else {
      enqueueSnackbar(
        res?.msg || "Could not save the note. Try again.",
        { variant: "error" },
      );
    }
  };

  return (
    <div className="w-full bg-white rounded-xl border border-gray-200 p-5 mt-4">
      <span className="block font-semibold text-gray-900 text-base mb-1">
        Notes
      </span>
      <p className="text-xs text-gray-500 mb-3">
        Leave a note for teammates so the next person knows what you already
        checked with the airline or agent.
      </p>

      {data?.remark ? (
        <div className="text-sm mb-3 rounded-lg bg-gray-50 p-3">
          <span className="font-medium text-gray-900">Request remark: </span>
          <span className="text-gray-700">{data.remark}</span>
        </div>
      ) : null}

      <div className="text-sm mb-4">
        {conversation?.map((item, messageIndex) => (
          <span className="block mb-1" key={item?._id || messageIndex}>
            <span className="font-medium text-gray-900">
              {user?._id === item?.account ? "Me" : "Note"}:
            </span>{" "}
            <span className="text-gray-700">{item?.message}</span>
          </span>
        ))}
      </div>

      {canReply ? (
        <>
          <textarea
            rows="4"
            placeholder="e.g. Partial refundable — airline confirmed penalty on PNR BBQ2UU"
            className="w-full bg-gray-100 text-sm rounded-lg p-3 text-gray-700 border border-gray-200 outline-none resize-none"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <div className="flex items-center justify-end mt-4">
            <button
              type="button"
              disabled={loading}
              className="bg-primary1 disabled:bg-gray-400 text-white text-sm font-medium px-4 h-9 rounded-md"
              onClick={() => handleReply()}
            >
              {loading ? <div className="buttonLoader"></div> : "Save note"}
            </button>
          </div>
        </>
      ) : null}
    </div>
  );
}

export default RefundConfirmationRemarks;
